module.exports = __webpack_public_path__ + "static/assets/7c74d1187f403ff0ce14c54989f8cb09.png";